/** Enable the catalog only on reviewed sandbox origins; mutations still require Telegram auth. */
type SandboxPreviewEnvironment = {
  VITE_SANDBOX_CATALOG_PREVIEW?: string | boolean;
};

const PUBLIC_CATALOG_ORIGIN = "https://freevito.fidelio.pro";
const LAN_CATALOG_HOSTS = new Set(["127.0.0.1", "localhost", "10.0.0.10"]);

function isLanCatalogOrigin(origin: string): boolean {
  try {
    const value = new URL(origin);
    return value.protocol === "http:" && LAN_CATALOG_HOSTS.has(value.hostname);
  } catch {
    return false;
  }
}

export function isSandboxCatalogPreview(
  environment: SandboxPreviewEnvironment,
  search: string,
  isNonTelegramBrowser: boolean,
  origin: string,
): boolean {
  if (environment.VITE_SANDBOX_CATALOG_PREVIEW !== "1" || !isNonTelegramBrowser) {
    return false;
  }
  if (origin === PUBLIC_CATALOG_ORIGIN) {
    return true;
  }
  return isLanCatalogOrigin(origin) && new URLSearchParams(search).get("catalog") === "server";
}
